import { BaseService } from '../../infra/base.service'
import type { Referral } from './referral'
import type { ReferralsRepository } from './referrals.repository'

export class ReferralsService extends BaseService<Referral> {
    constructor(private rep: ReferralsRepository) {
        super(rep)
    }
}
